import React from 'react';
import { useSelector } from 'react-redux';
import { PasslyButton } from '@app/components';
import { Button } from '@itglue/kaseya-ui';

export interface IButtonsData {
    primaryBtn?: string;
    secondaryBtn?: string;
    onClickPrimary?: Function;
    onClickSecondary?: Function;
    disabled?: boolean;
    id: string;
    isDeleteAction?: boolean;
    withBorder?: boolean;
}

export function ModalActionsComponent(props: any) {
    const loaderBtnState: boolean = useSelector((state: any) => state.modal.modalLoaderBtn);

    return (
        <>
            <div className={`modal__actions ${props.withBorder ? 'modal__actions-border' : ''}`}>
                {props.secondaryBtn && (
                    <PasslyButton
                        id='verify'
                        additionalColor='tertiary'
                        className='modal__actions-tertiary'
                        onClick={props.onClickSecondary}
                    >
                        {props.secondaryBtn}
                    </PasslyButton>
                )}
                {props.primaryBtn && !props.isDeleteAction && (
                    <PasslyButton
                        id={props.id}
                        onClick={props.onClickPrimary}
                        className='modal__actions-primary'
                        variant='contained'
                        color='primary'
                        disabled={props.disabled || loaderBtnState}
                        isLoading={loaderBtnState}
                    >
                        {props.primaryBtn}
                    </PasslyButton>
                )}
                {props.primaryBtn && props.isDeleteAction && (
                    <Button
                        className='modal__actions-primary'
                        autoWidth={true}
                        label={props.primaryBtn}
                        variant='danger'
                        size='regular'
                        onClick={props.onClickPrimary}
                        disabled={props.disabled || loaderBtnState}
                        isLoading={loaderBtnState}
                    />
                )}
            </div>
        </>
    );
}